/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Active/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import Children from 'Simple/Children'
import React from 'react'
import TysiaText from 'DesignSystem/TysiaText/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Active({
  children,
  viewPath = "/App/Account/Topbar/Inbox/Content/MessageIndicatorIcon/Content/Active"
  
}) {
let dtSpaceXxxs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xxxs'
        })
let dtSpaceXxs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xxs'
        })
let dtColorsRed600 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.red.600'
        })
let inboxUnreadCountAggregateCountValueData = fromData.useDataValue({ viewPath,
context: 'inbox_unread_count',
path: 'aggregate.count',
})
let dtColorsWhite = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.white'
        })
  return (<React.Fragment
>
<div
  data-testid="Active.Vertical"
  data-view-path={viewPath}
 className={`views-block ${styles.Vertical}`}
>
<div
  data-testid="Active.Vertical:1"
  data-view-path={viewPath}
 style={{'--pb-1-2jfVU5': typeof dtSpaceXxxs === 'number' ? `${dtSpaceXxxs}px` : dtSpaceXxxs,'--pt-2-2jfVU5': typeof dtSpaceXxs === 'number' ? `${dtSpaceXxs}px` : dtSpaceXxs,'--pr-3-2jfVU5': typeof dtSpaceXxxs === 'number' ? `${dtSpaceXxxs}px` : dtSpaceXxxs,'--pl-4-2jfVU5': typeof dtSpaceXxxs === 'number' ? `${dtSpaceXxxs}px` : dtSpaceXxxs,'--bblr-5-2jfVU5': typeof dtSpaceXxxs === 'number' ? `${dtSpaceXxxs}px` : dtSpaceXxxs,'--bbrr-6-2jfVU5': typeof dtSpaceXxxs === 'number' ? `${dtSpaceXxxs}px` : dtSpaceXxxs,'--btlr-7-2jfVU5': typeof dtSpaceXxxs === 'number' ? `${dtSpaceXxxs}px` : dtSpaceXxxs,'--btrr-8-2jfVU5': typeof dtSpaceXxxs === 'number' ? `${dtSpaceXxxs}px` : dtSpaceXxxs,'--bc-9-2jfVU5': dtColorsRed600}}
 className={`views-block ${styles.Vertical1}`}
>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 size="tiny"
 color={dtColorsWhite}
 data="inbox_unread_count.aggregate.count"
 text={inboxUnreadCountAggregateCountValueData}
/>
</div>
<div
  data-testid="Active.Vertical:2"
  data-view-path={viewPath}
 className={`views-block ${styles.Vertical2}`}
>
<Children
  viewPath={`${viewPath}/Children`}
 times={8}
 size={14}
 color={dtColorsWhite}
>
{children}
</Children>
</div>
</div>
</React.Fragment>)
}